import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { Link } from 'site-modules/shared/components/link/link';

export const getCards = ({
  vehicles,
  cardProps,
  srpLink,
  addViewAllCard,
  isPartnerListing,
  cardComponent: CardComponent,
}) => {
  const VEHICLES_TO_SHOW = 4;
  const cards = [];
  let key = 0;
  if (addViewAllCard) {
    vehicles.push({ isViewAllCard: true });
  }

  while (vehicles.length) {
    const vehiclesToRender = vehicles.splice(0, VEHICLES_TO_SHOW);
    const numberOfCards = vehiclesToRender.length;

    cards.push(
      <Row className="rows-wrapper g-0 w-100" key={key}>
        <Row className="row-container flex-nowrap g-0 w-100">
          {vehiclesToRender.map(vehicle =>
            vehicle && vehicle.isViewAllCard ? (
              <Col
                className="column-card p-0 mb-1_5"
                key="view-all-card"
                xs="auto"
                style={numberOfCards === 1 ? { height: '350px' } : null}
              >
                <div className="view-all d-flex justify-content-center align-items-center rounded bg-white h-100">
                  <Link
                    to={srpLink}
                    className="d-flex flex-column justify-content-center align-items-center text-primary-darker size-16 py-0_5 h-100 w-100"
                    data-tracking-id="view_search_result"
                  >
                    <span className="text-transform-none fw-normal size-20">View All</span>
                    <div className="circle-btn rounded-circle d-flex justify-content-center align-items-center mt-1">
                      <i className="size-20 icon icon-arrow-right2" aria-hidden />
                    </div>
                  </Link>
                </div>
              </Col>
            ) : (
              <Col className="column-card p-0 mb-1_5" key={vehicle.vin} xs="auto">
                <CardComponent vehicle={vehicle} {...cardProps} isVdpPartnerListing={isPartnerListing} />
              </Col>
            )
          )}
        </Row>
      </Row>
    );
    key += 1;
  }

  return cards;
};
